import React from 'react';

// Nexus Core (DESIGN.md §6 Tabs - 下線型)
// active = Nexus Primary 下線 + 文字色、非 active = Text Secondary
export default function Tabs({ value, onChange, tabs, className = '' }) {
  return (
    <div className={`flex border-b border-border-light px-6 ${className}`}>
      {tabs.map((tab) => {
        const active = tab.key === value;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`relative px-4 py-3 text-sm font-medium transition-colors ${
              active ? 'text-nexus-primary' : 'text-text-secondary hover:text-text-primary'
            }`}
          >
            {tab.label}
            {active && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-nexus-primary rounded-t" />
            )}
          </button>
        );
      })}
    </div>
  );
}
